import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const OrderRoom = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="OrderRoom" {...rest}>
      <path
        d="M14.39 19.38L7.21999 17.51C7.1739 17.4997 7.12609 17.4997 7.07999 17.51C6.95424 17.5118 6.83236 17.5538 6.73213 17.6297C6.6319 17.7057 6.55857 17.8117 6.52284 17.9323C6.48712 18.0529 6.49085 18.1818 6.53352 18.3001C6.57618 18.4184 6.65553 18.52 6.75999 18.59L12.21 22H15.81L17.81 18.85C17.8965 18.717 17.9455 18.5631 17.9518 18.4046C17.958 18.246 17.9212 18.0888 17.8454 17.9494C17.7696 17.81 17.6575 17.6938 17.521 17.6129C17.3845 17.532 17.2287 17.4896 17.07 17.49C16.8702 17.4875 16.6757 17.5547 16.52 17.68L14.39 19.38Z"
        fill="currentColor"
      />
      <path
        d="M12 5.5C13.9937 5.50312 15.9232 6.20532 17.4526 7.48435C18.9819 8.76339 20.0143 10.5383 20.37 12.5H3.63C3.98568 10.5383 5.01807 8.76339 6.54744 7.48435C8.0768 6.20532 10.0063 5.50312 12 5.5ZM12 4C10.6868 4 9.38642 4.25866 8.17317 4.7612C6.95991 5.26375 5.85752 6.00035 4.92893 6.92893C3.05357 8.8043 2 11.3478 2 14H22C22 11.3478 20.9464 8.8043 19.0711 6.92893C17.1957 5.05357 14.6522 4 12 4Z"
        fill="currentColor"
      />
      <path
        d="M12 2.75C11.6022 2.75 11.2206 2.90804 10.9393 3.18934C10.658 3.47064 10.5 3.85218 10.5 4.25H13.5C13.5 3.85218 13.342 3.47064 13.0607 3.18934C12.7794 2.90804 12.3978 2.75 12 2.75Z"
        fill="currentColor"
      />
      <path
        d="M12 6C13.7743 5.99911 15.4985 6.58806 16.9014 7.67421C18.3044 8.76036 19.3064 10.2821 19.75 12H4.25C4.69356 10.2821 5.69563 8.76036 7.09858 7.67421C8.50153 6.58806 10.2257 5.99911 12 6ZM12 4C10.6868 4 9.38642 4.25866 8.17317 4.7612C6.95991 5.26375 5.85752 6.00035 4.92893 6.92893C3.05357 8.8043 2 11.3478 2 14H22C22 11.3478 20.9464 8.8043 19.0711 6.92893C17.1957 5.05357 14.6522 4 12 4Z"
        fill="currentColor"
      />
      <path
        d="M12 2.75C11.6022 2.75 11.2206 2.90804 10.9393 3.18934C10.658 3.47064 10.5 3.85218 10.5 4.25H13.5C13.5 3.85218 13.342 3.47064 13.0607 3.18934C12.7794 2.90804 12.3978 2.75 12 2.75Z"
        fill="currentColor"
      />
      <path
        d="M22 15H2C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17H22C22.5523 17 23 16.5523 23 16C23 15.4477 22.5523 15 22 15Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
